import {
    decrementValue,
    incrementValue,
    matchLabelFromSelectionIfExists,
    matchValueFromManualInputIfExists,
    matchValueFromSelectionIfExists,
} from '@mfe-helpers/fieldMethods';
import {
    formatBooleanValue,
    formatNumberInputValue,
    formatRange,
    formatTextInputValue,
} from '@mfe-helpers/format';
import { EUIComponent } from '@mfe-types/enum';
import type {
    AutoCompleteField,
    CheckboxField,
    IncrementalField,
    MaxRangeField,
    NumberField,
    RadioBooleanField,
    RadioField,
    SelectField,
    TextField,
} from '@mfe-types/field';

export const defaultTextField: TextField = {
    uiComponent: EUIComponent.TextField,
    formatInputValue: formatTextInputValue,
    defaultValue: '',
    isRequired: true,
};

export const defaultMaxRangeField: MaxRangeField = {
    uiComponent: EUIComponent.TextField,
    formatInputValue: formatRange,
    type: 'text',
    inputMode: 'decimal',
    defaultValue: '',
    isRequired: true,
};

export const defaultIncrementalField: IncrementalField = {
    uiComponent: EUIComponent.Incremental,
    defaultValue: 1,
    formatInputValue: formatRange,
    type: 'text',
    options: {
        decrementFn: decrementValue,
        incrementFn: incrementValue,
    },
    isRequired: true,
};

export const defaultCustomIncrementalField: IncrementalField = {
    ...defaultIncrementalField,
    options: {
        decrementFn: decrementValue,
        incrementFn: incrementValue,
        matchLabelFromSelectionIfExists,
        matchValueFromSelectionIfExists,
        matchValueFromManualInputIfExists,
    },
};

export const defaultNumberField: NumberField = {
    uiComponent: EUIComponent.TextField,
    formatInputValue: formatNumberInputValue,
    type: 'text',
    defaultValue: '',
    isRequired: true,
};

export const defaultRadioField: RadioField = {
    uiComponent: EUIComponent.RadioCard,
    formatInputValue: formatTextInputValue,
    options: { values: () => [] },
    isRequired: true,
};

export const defaultRadioBooleanField: RadioBooleanField = {
    uiComponent: EUIComponent.Radio,
    formatInputValue: formatBooleanValue,
    defaultValue: true,
    options: { values: () => [] },
    isRequired: true,
};

export const defaultSelectField: SelectField = {
    uiComponent: EUIComponent.Select,
    formatInputValue: formatTextInputValue,
    defaultValue: '',
    options: { values: () => [] },
    isRequired: true,
};

export const defaultCheckboxField: CheckboxField = {
    uiComponent: EUIComponent.Checkbox,
    formatInputValue: formatBooleanValue,
    defaultValue: false,
    isRequired: false,
};

export const defaultAutocompleteField: AutoCompleteField = {
    uiComponent: EUIComponent.StreetAutocomplete,
    formatInputValue: formatTextInputValue,
    defaultValue: '',
    isRequired: true,
};
